import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPaymentCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "6 11.5 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.222 11.5H7.778C6.796 11.5 6 12.284 6 13.25v17.5c0 .966.796 1.75 1.778 1.75h28.444c.982 0 1.778-.784 1.778-1.75v-17.5c0-.966-.796-1.75-1.778-1.75z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.96 26.97h-.046v-.271h.069l.088.19.076-.19h.067v.268h-.047v-.202l-.073.174h-.054l-.08-.174V26.969zm-.2-.002h-.04v-.223h-.093V26.7h.234v.046h-.1v.223z",
    fill: "#F69E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.52 16.383h-6.807v11.425h6.807V16.383z",
    fill: "#F26122"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.445 22.095a7.274 7.274 0 01.684-3.15 7.385 7.385 0 011.983-2.563 6.934 6.934 0 00-4.946-1.531 6.898 6.898 0 00-4.623 2.313 7.435 7.435 0 00-1.877 4.93c0 1.814.667 3.565 1.877 4.932a6.9 6.9 0 004.623 2.313 6.934 6.934 0 004.946-1.532 7.386 7.386 0 01-1.983-2.562 7.273 7.273 0 01-.684-3.15z",
    fill: "#EA1D25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.552 22.095a7.215 7.215 0 01-1.056 3.818 7.371 7.371 0 01-2.925 2.714 6.927 6.927 0 01-7.459-.818 7.45 7.45 0 002.65-4.868 7.398 7.398 0 00-1.463-5.332 7.035 7.035 0 00-1.187-1.226 6.926 6.926 0 017.459-.819 7.37 7.37 0 012.924 2.714 7.215 7.215 0 011.057 3.817z",
    fill: "#F69E1E"
  })));
}

export { SvgPaymentCard as ReactComponent };
